import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import TaskAppResource from "./TaskAppResource";

export const DAY_INTERVAL = 'day';
export const WEEK_INTERVAL = 'week';
export const MONTH_INTERVAL = 'month';
export const YEAR_INTERVAL = 'year';

/**
 * @class TaskRecurrenceAppResource
 * @extends AppResource
 */
class TaskRecurrenceAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'task-recurrence';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'tasks/recurrences';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'startDate',
            'endDate',
            'occurrence',
            'interval',
            'tasks',
            'isDefault',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            tasks: TaskAppResource,
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            startDate: {
                presence: true,
                datetime: true,
            },
            endDate: {
                datetime: true,
            },
            occurrence: {
                presence: true,
                numericality: true,
            },
            interval: {
                presence: true,
                type: 'string',
                inclusion: [DAY_INTERVAL, WEEK_INTERVAL, MONTH_INTERVAL, YEAR_INTERVAL],
            },
            isDefault: {
                type: 'boolean',
            },
        };
    }
}

export default TaskRecurrenceAppResource;
